import { render, staticRenderFns } from "./TheIvgNumber.vue?vue&type=template&id=40e905de&scoped=true"
import script from "./TheIvgNumber.vue?vue&type=script&lang=ts"
export * from "./TheIvgNumber.vue?vue&type=script&lang=ts"
import style0 from "./TheIvgNumber.vue?vue&type=style&index=0&id=40e905de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e905de",
  null
  
)

export default component.exports